import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { ThemeToggle } from "./ThemeToggle";
import { ChangePasswordButton } from "./ChangePasswordButton";
import { useAuth } from "../context/AuthContext";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <img src="/logo-la.png" alt="LA Marcenaria" data-testid="brand-logo" className="h-14 w-auto py-1" />
    <p className="hidden sm:block font-mono text-[10px] uppercase tracking-[0.2em] text-[#D1D5DB] leading-tight">Plano de<br />corte</p>
  </div>
);

export const AppHeader = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 h-[68px] border-b border-[#2D333F] bg-[#0F1115]/85 backdrop-blur-xl">
      <div className="h-full px-4 sm:px-6 lg:px-8 flex items-center gap-4">
        <Link to="/" data-testid="header-logo-link"><Logo /></Link>
        <div className="flex-1 min-w-0">{children}</div>
        <ThemeToggle />
        {user && (
          <div className="flex items-center gap-3">
            <span data-testid="header-user-name" className="hidden md:block text-sm text-[#9CA3AF] truncate max-w-[180px]">{user.name || user.email}</span>
            <ChangePasswordButton />
            <button
              data-testid="logout-btn"
              onClick={async () => { await logout(); nav("/login"); }}
              className="p-2 rounded-md hover:bg-[#21252F] text-[#9CA3AF] hover:text-white transition-colors"
              title="Sair"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
